module.exports = {"140525100":"南村镇","140525101":"下村镇","140525102":"大东沟镇","140525103":"周村镇","140525104":"犁川镇","140525105":"晋庙铺镇","140525106":"金村镇","140525107":"高都镇","140525108":"巴公镇","140525109":"大阳镇","140525110":"山河镇","140525111":"大箕镇","140525112":"柳树口镇","140525113":"北义城镇","140525200":"川底乡","140525201":"李寨乡","140525202":"南岭乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140525.json
// module id = 273
// module chunks = 0